(() => {
  /* If number of slides is less than slidesPerView * 2, duplicate slides */
  const setSlides = (sliders) => {
    if (sliders && sliders.length > 0) {
      sliders.forEach((swiper) => {
        let SLIDES_REQUIRED;
        const wrapper = swiper.querySelector(".swiper-wrapper");
        const srcElems = wrapper.querySelectorAll(".logo-list__item");
        const isHorizontal = swiper.classList.contains(
          "logo-list__content--horizontal-carousel"
        );

        if (window.matchMedia("(min-width: 1200px)").matches) {
          if (srcElems.length > 5) {
            SLIDES_REQUIRED = isHorizontal ? 12 : 6;
          } else {
            SLIDES_REQUIRED = srcElems.length;
          }
        } else if (window.matchMedia("(min-width: 990px)").matches) {
          if (srcElems.length > 4) {
            SLIDES_REQUIRED = isHorizontal ? 8 : 6;
          } else {
            SLIDES_REQUIRED = srcElems.length;
          }
        } else if (window.matchMedia("(min-width: 750px)").matches) {
          if (srcElems.length > 3) {
            SLIDES_REQUIRED = isHorizontal ? 6 : 6;
          } else {
            SLIDES_REQUIRED = srcElems.length;
          }
        } else {
          if (srcElems.length > 2) {
            SLIDES_REQUIRED = isHorizontal ? 4 : 6;
          } else {
            SLIDES_REQUIRED = srcElems.length;
          }
        }

        let cloneCount = 0;
        const currentCount =
          wrapper.querySelectorAll(".logo-list__item").length;
        if (currentCount >= 8) {
          while (
            wrapper.querySelectorAll(".logo-list__item").length <
              SLIDES_REQUIRED &&
            cloneCount < 3
          ) {
            srcElems.forEach((el) => {
              const cloneElem = el.cloneNode(true);
              wrapper.appendChild(cloneElem);
            });
            cloneCount++;
          }
        } else {
          while (wrapper.querySelectorAll(".logo-list__item").length < 16) {
            srcElems.forEach((el) => {
              if (wrapper.querySelectorAll(".logo-list__item").length >= 16)
                return;
              const cloneElem = el.cloneNode(true);
              wrapper.appendChild(cloneElem);
            });
          }
        }
      });
    }
  };

  const recalculateSlidesLength = () => {
    setSlides(document.querySelectorAll(".js-slider-logos"));
    setSlides(document.querySelectorAll(".js-slider-logos-slow"));
  };

  /* LOBO CUSTOM H18 (Etapa 12): en móvil (menos de 750 px) el carrusel horizontal de logos pasa de Swiper (una diapositiva
     por vez, con `loop: false` y la mitad de duración) a un desplazamiento continuo con una animación CSS lineal.
     Antes: 89 px/s en móvil contra 56 px/s en escritorio (misma duración por diapositiva, pero la diapositiva de móvil
     es más ancha), una micropausa en cada cambio de logo (Swiper espera el fin de cada transición para lanzar la
     siguiente) y, al llegar al último, un retroceso rápido al primero. Ahora la velocidad en píxeles por segundo es la de
     escritorio a 1440 px (paso de 199 + 24 px por diapositiva cada `data-duration` ms) y se mueve sin cortes.
     Escritorio y tablet siguen con Swiper sin cambios. Los estilos están en `assets/lobo-custom.css` (C72). */
  const LOBO_MARQUEE_REF_PITCH = 223.67;

  const stopMarquee = (el) => {
    if (el.loboStopMarquee) el.loboStopMarquee();
  };

  const startMarquee = (el, duration) => {
    stopMarquee(el);
    const wrapper = el.querySelector(".swiper-wrapper");
    const items = wrapper ? Array.from(wrapper.querySelectorAll(".logo-list__item")) : [];
    if (items.length === 0) return;

    const clones = items.map((item) => {
      const clone = item.cloneNode(true);
      clone.classList.add("lobo-marquee-clone");
      clone.setAttribute("aria-hidden", "true");
      clone.querySelectorAll("a").forEach((link) => link.setAttribute("tabindex", "-1"));
      wrapper.appendChild(clone);
      return clone;
    });

    /* 2 logos por vista y 16 px entre ellos, igual que la configuración de Swiper en móvil */
    const pitch = (el.clientWidth + 16) / 2;
    const shift = items.length * pitch;
    const pxPerSecond = LOBO_MARQUEE_REF_PITCH / (duration / 1000);
    wrapper.style.setProperty("--lobo-marquee-shift", `${shift}px`);
    wrapper.style.setProperty("--lobo-marquee-time", `${shift / pxPerSecond}s`);
    el.classList.add("logo-list__content--marquee", "swiper-initialized");

    el.loboStopMarquee = () => {
      clones.forEach((clone) => clone.remove());
      wrapper.style.removeProperty("--lobo-marquee-shift");
      wrapper.style.removeProperty("--lobo-marquee-time");
      el.classList.remove("logo-list__content--marquee", "swiper-initialized");
      delete el.loboStopMarquee;
    };
  };
  /* /LOBO CUSTOM H18 */

  const initSlider = (section) => {
    let logosSlider;
    let logosSliderSlow;

    if (document.currentScript) {
      logosSlider =
        document.currentScript.parentElement.querySelectorAll(
          ".js-slider-logos"
        );
      logosSliderSlow = document.currentScript.parentElement.querySelectorAll(
        ".js-slider-logos-slow"
      );
    } else {
      logosSlider = section.querySelectorAll(".js-slider-logos");
      logosSliderSlow = section.querySelectorAll(".js-slider-logos-slow");
    }

    if (logosSlider && logosSlider.length > 0) {
      logosSlider.forEach((el) => {
        const speed1 = el.getAttribute("data-duration") || 4000;

        /* LOBO CUSTOM H18 */
        if (
          window.matchMedia("(max-width: 749px)").matches &&
          el.classList.contains("logo-list__content--horizontal-carousel")
        ) {
          startMarquee(el, Number(speed1) || 4000);
          return;
        }
        /* /LOBO CUSTOM H18 */

        const isMobile = window.matchMedia("(max-width: 750px)").matches;
        const adjustedSpeed = isMobile
          ? Math.max(2000, Math.ceil(speed1 / 2))
          : speed1;

        const logosSwiper1 = new Swiper(el, {
          slidesPerView: el.classList.contains(
            "logo-list__content--horizontal-carousel"
          )
            ? 2
            : 3,
          spaceBetween: 16,
          autoplay: {
            delay: 1,
          },
          direction: "horizontal",
          loop: !isMobile,
          speed: adjustedSpeed,
          shortSwipes: false,
          longSwipes: false,
          allowTouchMove: false,
          loopedSlides: 10,
          breakpoints: {
            750: {
              direction: el.classList.contains(
                "logo-list__content--vertical-carousel"
              )
                ? "vertical"
                : "horizontal",
              slidesPerView: 3,
              spaceBetween: 20,
            },
            990: {
              direction: el.classList.contains(
                "logo-list__content--vertical-carousel"
              )
                ? "vertical"
                : "horizontal",
              slidesPerView: el.classList.contains(
                "logo-list__content--horizontal-carousel"
              )
                ? 4
                : 3,
              spaceBetween: 24,
            },
            1200: {
              direction: el.classList.contains(
                "logo-list__content--vertical-carousel"
              )
                ? "vertical"
                : "horizontal",
              slidesPerView: el.classList.contains(
                "logo-list__content--horizontal-carousel"
              )
                ? 6
                : 3,
              spaceBetween: 24,
            },
          },
        });
      });
    }

    if (logosSliderSlow && logosSliderSlow.length > 0) {
      logosSliderSlow.forEach((el) => {
        const speed2 = el.getAttribute("data-duration") || 4000;

        const isMobile = window.matchMedia("(max-width: 750px)").matches;
        const adjustedSpeed = isMobile
          ? Math.max(2000, Math.ceil(speed2 / 2))
          : speed2;

        const logosSwiper2 = new Swiper(el, {
          slidesPerView: 3,
          spaceBetween: 16,
          autoplay: {
            delay: 1,
          },
          direction: "horizontal",
          loop: !isMobile,
          speed: adjustedSpeed,
          shortSwipes: false,
          longSwipes: false,
          allowTouchMove: false,
          loopedSlides: 10,
          breakpoints: {
            750: {
              direction: "vertical",
              slidesPerView: 3,
              spaceBetween: 20,
            },
            990: {
              direction: "vertical",
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },
        });
      });
    }
  };

  const initSection = (section) => {
    let sectionLogos;

    if (document.currentScript) {
      sectionLogos = document.currentScript.parentElement;
    } else {
      sectionLogos = section;
    }

    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      const sliders = entry.target.querySelectorAll(".js-slider-logos");
      const slidersSlow = entry.target.querySelectorAll(
        ".js-slider-logos-slow"
      );

      if (sliders.length != 0) {
        sliders.forEach((slider) => {
          stopMarquee(slider); /* LOBO CUSTOM H18 */
          if (slider.swiper) slider.swiper.destroy();
        });
      }

      if (slidersSlow.length != 0) {
        slidersSlow.forEach((slider) => {
          if (slider.swiper) slider.swiper.destroy();
        });
      }

      recalculateSlidesLength();
      initSlider(sectionLogos);
    });

    recalculateSlidesLength();
    initSlider(sectionLogos);

    sectionResizeObserver.observe(sectionLogos);
  };

  initSection();

  document.addEventListener("shopify:section:load", function (section) {
    initSection(section.target);
  });
})();
